import Request from '../../../../src/core/gd/data/request'
import {ViewType} from "../const/views/view-type";
import {PortfolioUserAccess} from "../const/portfolio";
import {SystemStatus} from "../const/system-status"
import {ApiSelectFields, ApiSystemStatus} from "../manager/universal-task-selector/@types"

// const debug = "ApiPortfolio"
const debug = false

export default class ApiPortfolio {

    create(params: {
        name        : string
        settings    : any
        views       : {
            id              : ID
            name?           : string
            systemType      : ViewType,
            isMandatory?    : boolean

        }[]
        sharedUsers : ID[]
        users       : {
            userId      : ID
            access      : PortfolioUserAccess
        }[]
    }) {
        return new Request(this,'POST','portfolio/create', params)
    }

    view(portfolioId: ID) {
        return new Request(this,'GET','portfolio/{0}'.f(portfolioId), {}, true, false)
    }

    delete(portfolioId: ID) {
        return new Request(this,'DELETE','portfolio/{0}'.f(portfolioId))
    }

    update(portfolioId: ID, params: any) {
        return new Request(this,'PUT','portfolio/{0}'.f(portfolioId), params)
    }

    static getSummaryDataV2(projectIds: ID[], fields: ApiSelectFields[] = []) {
        debug && console.log(debug, 'getSummaryDataV2', projectIds, fields)

        return new Request(this,'POST','uds/projects-summary', {
            projectIds  : projectIds,
            fields      : fields
        })
    }

    getSummaryData(projectIds: ID[], fields: ApiSelectFields[] = []) {
        debug && console.log(debug, 'getSummaryData', projectIds, fields)

        return new Request(this,'POST','uds/projects-summary', {
            projectIds  : projectIds,
            fields      : fields
        })
    }

    static getProjectsListV2(params: {
        systemStatuses?     : SystemStatus[],
        parentProjectIds?   : ID[],
        templateIds?        : ID[]
    }) {
        debug && console.log(debug, 'getProjectsList', params)

        return new Request(this,'POST','portfolio/projects-list', params)
    }

    getProjectsList(params: {
        systemStatuses?     : SystemStatus[],
        parentProjectIds?   : ID[],
        templateIds?        : ID[]
    }) {
        debug && console.log(debug, 'getProjectsList', params)

        return new Request(this,'POST','portfolio/projects-list', params)
    }

    _getSystemTaskStatuses(systemStatus: 'open' | 'closed') {
        switch (systemStatus) {
            case 'open'     : return gd.const.systemStatus.OPEN_STATUSES
            case 'closed'   : return gd.const.systemStatus.CLOSED_STATUSES
        }

        return undefined
    }

    static getTasksDataV2(projectIds: ID[], selectFields: ID[], systemStatus: ApiSystemStatus) {

        let systemTaskStatuses
        switch (systemStatus) {
            case ApiSystemStatus.OPEN:
                systemTaskStatuses = gd.const.systemStatus.OPEN_STATUSES
                break

            case ApiSystemStatus.CLOSED:
                systemTaskStatuses = gd.const.systemStatus.CLOSED_STATUSES
                break

            default:
                // systemTaskStatuses undefined - will return all statuses
                break
        }

        /*const params = {
            "projectIds"        : ["Ja7ua1","aa6uoT"],
            "selectFields"      : ["tags", "timeReports"],
            "systemTaskStatuses": [1,2,3,4,5,6]
        }*/

        return new Request(this,'POST','uds/tasks', {projectIds, selectFields, systemTaskStatuses})
    }

    getTasksData(projectIds: ID[], selectFields: ID[], systemStatus: 'open' | 'closed') {

        const systemTaskStatuses = this._getSystemTaskStatuses(systemStatus) // undefined - will return all statuses

        /*const params = {
            "projectIds"        : ["Ja7ua1","aa6uoT"],
            "selectFields"      : ["tags", "timeReports"],
            "systemTaskStatuses": [1,2,3,4,5,6]
        }*/

        return new Request(this,'POST','uds/tasks', {projectIds, selectFields, systemTaskStatuses})
    }

    getCalendarData(projectIds: ID[], params: any) {

        /*const params = {
            "projectIds": ["Ja7ua1","aa6uoT"],
            "eventTypes": [20, 21, 22, 24, 23, 40, 10, 11, 3, 2, 1, 30],
            "startDate" : "01-01-2022",
            "endDate"   : "01-01-2022",
        }*/

        return new Request(this,'POST','uds/calendar', _.assign({projectIds}, params))
    }

    static getWorkloadDataV2(projectIds: ID[], params: any) {

        /*const params = {
            "projectIds": ["Ja7ua1","aa6uoT"],
            "openOnly"  : true,
            "startDate" : "01-01-2022",
            "endDate"   : "01-01-2022",
        }*/

        _.map(params.fields, field => {
            params[field] = true
        })
        delete params.fields

        return new Request(this,'POST','uds/workload', _.assign({projectIds}, params))
    }

    getWorkloadData(projectIds: ID[], params: any) {

        /*const params = {
            "projectIds": ["Ja7ua1","aa6uoT"],
            "openOnly"  : true,
            "startDate" : "01-01-2022",
            "endDate"   : "01-01-2022",
        }*/

        return new Request(this,'POST','uds/workload', _.assign({projectIds}, params))
    }

    getGanttData(projectIds: ID[], systemStatus: 'open' | 'closed') {
        let systemTaskStatuses = this._getSystemTaskStatuses(systemStatus) // undefined - will return all statuses
        if (!systemTaskStatuses) systemTaskStatuses = [1,2,3,4,5,6]

        return new Request(this,'POST','uds/gantt', {
            projectIds              : projectIds,
            systemTaskStatuses      : systemTaskStatuses
        })
    }
}
